export default __webpack_public_path__ + "static/media/Avatar2.5faf09a7.png";